import { StrictMode } from "react";
import { createPortal } from "react-dom";
import { createRoot } from "react-dom/client";
import { zodUnsafeValidate } from "@/utils/zod";
import { ModuleFeedbackContext } from "./context/ModuleFeedbackContext";
import { ModuleFeedbackSchema } from "./schema";

export const createModuleFeedback = async () => {
  if (window.moduleFeedbackConfig !== undefined) {
    const { Feedback } = await import("./components/module-feedback/Feedback");

    const config = zodUnsafeValidate(
      ModuleFeedbackSchema.Config,
      window.moduleFeedbackConfig,
    );

    const container = document.createElement("div");
    const root = createRoot(container);

    const onClose = () => {
      root.unmount();
    };

    root.render(
      <StrictMode>
        {createPortal(
          <ModuleFeedbackContext.Provider
            value={{
              config,
            }}
          >
            <Feedback onClose={onClose} />
          </ModuleFeedbackContext.Provider>,
          document.body,
        )}
      </StrictMode>,
    );
  }
};
